/**hash용 시간포맷*/
function getHashTime(): string {
	const date = new Date();
	const day = String(date.getDate()).padStart(
		2,
		'0'
	);
	const hours = String(date.getHours()).padStart(
		2,
		'0'
	);
	const minutes = String(
		date.getMinutes()
	).padStart(2, '0');
	const seconds = String(
		date.getSeconds()
	).padStart(2, '0');
	return (
		'#' +
		encodeURIComponent(
			`${day}${hours}${minutes}${seconds}`
		)
	);
}
import router from '@/router';
import json from '../json/news.json';

interface NewsItem {
	title: string;
	boardClf: string;
	date: string;
	image: string | null;
	link: string | null;
	content: string | null;
	newsSn: number;
}

class utils {
	static newsClick(newsSn:number) {
		const allNews: NewsItem[] = json as NewsItem[];
		if (allNews.find((news:NewsItem):boolean=>news.newsSn==newsSn)!.link!=null) {
						window.open(
							allNews.find((news:NewsItem):boolean=>news.newsSn==newsSn)!.link!,
							'_blank'
						);
					} else {
						router.push({
							name: 'news_dtl',
							query: {
								newsSn: newsSn,
								key: getHashTime(),
							},
						});
					}
				}
}
export { getHashTime };
export default utils;
